import store from "../store/index"
import mqtt from "mqtt";
let client
let theSecond
function createTopics(loopTag) {
    return loopTag.map(l => {
        let loopTags1 = l.split("/")
        // let lutai=store.state.subLoopUrl.Loop
        // let lutai = store.state.subLoopUrl.Loop.split("/")
        // console.log()
        // 山东鲁泰TEST需要改成"LTC"
        // console.log(`VrMaker/LT/#`)
        return `VrMaker/LT/+/+/${loopTags1[0]}/${loopTags1[1]}/#`
    })
}
//发送合闸分闸数据
export function publishFun(titleAll, switc, num) {
    // let all = titleAll.split("/")
    let loopnum = switc.split("/") 
    console.log(`VrMaker/LT/${loopnum[0]}/SUBSCRIBE/${loopnum[1]}/${loopnum[2]}/${loopnum[3]}/${loopnum[4]}`, num + '')
    theSecond.publish(`VrMaker/LT/${loopnum[0]}/SUBSCRIBE/${loopnum[1]}/${loopnum[2]}/${loopnum[3]}/${loopnum[4]}`, num + '');
}
// ["CX/ZTR14", "",....]
export async function subscribe(loopTag) {
    // console.log("subscribe：" + loopTag)
    client.subscribe(createTopics(loopTag));
}
export async function unsubscribe(loopTag) {
    // console.log(client);
    client.unsubscribe(createTopics(loopTag));
}

// export function subscribeTopic(topic){
//     client.subscribe(topic)
// }

export async function connect() {
    // client = mqtt.connect("mqtt://192.168.33.27:8083/mqtt", {
        //  client = mqtt.connect("mqtt://192.168.33.182:8083/mqtt", {
  // client = mqtt.connect("mqtt://192.168.1.14:8083/mqtt", {
        // client = mqtt.connect("mqtt://localhost:8083/mqtt", {



        //鲁泰线上专用，不能发送分合闸数据！切记不能发，后果自负。
    client = mqtt.connect("wss://local.vrmaker.com.cn:18888/mqtt", {  
        username: "vrmaker",
        password: "vrmaker",
    });
    // client = mqtt.connect("ws://192.168.33.182:8083/mqtt", {  
    //     username: "vrmaker",
    //     password: "vrmaker",
    // });
    
    theSecond=mqtt.connect("wss://local.vrmaker.com.cn/mq/ws",{
        username: "lt_gk",
        password: "vrmaker",
    })
    await new Promise((resolve) => {
        client.on("connect", () => {
            console.log("Mqtt connected ...");
            resolve();
        });
    })
    let temp = []
    // 每秒提交一次
    setInterval(() => {
        let list = [].concat(temp)
        temp = []
        store.dispatch("addMqttValList", list)
    }, 2000)
    client.on("message", (topic, message) => {
        console.log(topic, message.toString())
        let keys = topic.split('/')
        let len = keys.length
        let key = keys[len - 4] + '/' + keys[len - 3] + '/' + keys[len - 2] + '/' + keys[len - 1]
        let lutai = store.state.subLoopUrl.Loop.split("/")
        // console.log(store.state.subLoopUrl.Loop)
        store.commit("addMqttVal", {
            key,
            val: message.toString()
        })
        // if (keys[len - 2] == "MT") {
        // 	// console.log(121212)
        // 	store.commit("addMqttVal", {
        // 		key,
        // 		val: message.toString()
        // 	})
        // } else {
        // 	store.commit("addMqttVal", {
        // 		key,
        // 		val: Number(message)
        // 	})
        // }
        // store.commit("changeValue", "abc");
        // console.log(store.state.subLoopUrl.valuer)
        if (topic.includes(`PUBLISH/${store.state.subLoopUrl.getstatus}`)) {
            console.log(`VrMaker/LT/${lutai[0]}/PUBLISH/${store.state.subLoopUrl.getstatus}`);
            // console.log(topic, `VrMaker/LT/${lutai[0]}/PUBLISH/${store.state.subLoopUrl.getstatus}`)
            store.commit("changeValue", message.toString());
            console.log(store.state.subLoopUrl.valuer);
            // store.commit("statuLoop", message.toString());
            // console.log(store.state.subLoopUrl.valuer)
            temp.push({
                key,
                val: message.toString()
            })
        }

        // if (keys[len - 2] == "MT") {
        // 	console.log(121212)
        // 	temp.push({
        // 		key,
        // 		val: message.toString()
        // 	})
        // } else {
        // 	temp.push({
        // 		key,
        // 		val: Number(message)
        // 	})
        // }

    });

}